// Centralised gallery manifest. Each key matches a service/location slug and
// maps to an array of image objects. Drop new photos into
// `/public/gallery/<slug>/` then add a matching entry here.
//
// Image naming convention (helps SEO):
//   <service>-<short-description>-<location>.webp
//   e.g. emergency-plumber-burst-pipe-rochester.webp
//
// Alt text guidance: describe what is happening + the location.
//   "Engineer repairing burst copper pipe in kitchen, Rochester Kent"
//
// width/height help prevent Cumulative Layout Shift — set the actual file dims.

const G = (slug, src, alt, caption) => ({
  src: `/gallery/${slug}/${src}`,
  alt,
  caption,
  width: 1200,
  height: 800,
});

const GALLERY = {
  // ===== Service galleries =====
  'plumbing': [
    // Example entries — replace with real photos when uploaded.
    // G('plumbing', 'kitchen-sink-replacement-rochester.webp',
    //    'Engineer replacing kitchen sink and waste pipes, Rochester Kent',
    //    'Kitchen sink + waste replacement, Rochester'),
  ],
  'emergency-plumber': [],
  'handyman': [],
  'property-maintenance': [],
  'leak-detection-repairs': [],
  'blocked-drains': [],
  'toilet-repairs': [],
  'radiator-repairs': [],
  'tap-repairs': [],
  'air-conditioning': [],
  'refrigeration': [],

  // ===== Location galleries =====
  'plumber-rochester': [],
  'plumber-gillingham': [],
  'plumber-chatham': [],
  'plumber-maidstone': [],
  'handyman-rochester': [],
  'handyman-gillingham': [],
  'handyman-chatham': [],
};

export const getGallery = (slug) => GALLERY[slug] || [];
export default GALLERY;
